import React, { useState, useEffect } from "react";
import './CreateUser.css';
import axios from "axios";
import { useNavigate } from "react-router-dom";
const CreateUser = () => {
  const navigate = useNavigate();
  const [fullname, setUserName] = useState('');
  const [empId, setEmpId] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [designation, setDesignation] = useState('');
  const [mobileNum, setMobileNum] = useState('');
  const [roleId, setRoleId] = useState('');
  const [districtId, setDistrictId] = useState('');
  const [subDivisionId, setSubDivisionId] = useState('');
  const [blockId, setBlockId] = useState('');
  const [message, setMessage] = useState('');
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [districts, setDistricts] = useState([]);
  const [subDivisions, setSubDivisions] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [passwordStrength, setPasswordStrength] = useState('');
  const [passwordMatchError, setPasswordMatchError] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState(null);  // Define setError here

  const [designationName, setDesignationName] = useState([]);  // List of designations

  const [selectedDesignation, setSelectedDesignation] = useState("");
  const assessPasswordStrength = (password) => {
    if (password.length < 8) return 'Weak';
    if (/\d/.test(password) && /[a-zA-Z]/.test(password) && /[^a-zA-Z0-9]/.test(password)) {
      return 'Strong';
    } else if (/\d/.test(password) && /[a-zA-Z]/.test(password)) {
      return 'Medium';
    }
    return 'Weak';
  };
  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    setPasswordStrength(assessPasswordStrength(newPassword));
    if (confirmPassword && newPassword !== confirmPassword) {
      setPasswordMatchError('Passwords do not match.');
    } else {
      setPasswordMatchError('');
    }
  };
  // Handle confirm password input change
  const handleConfirmPasswordChange = (e) => {
    const newConfirmPassword = e.target.value;
    setConfirmPassword(newConfirmPassword);

    // Check if password and confirm password match
    if (password && newConfirmPassword !== password) {
      setPasswordMatchError('Passwords do not match.');
    } else {
      setPasswordMatchError('');
    }
  };

  // Token you provided (for testing purposes)
  const token = `${process.env.REACT_APP_AFTER_TOKEN}`;
  const baseUrl = `${process.env.REACT_APP_AUDIT_API_URL}/api`;  // Define the base URL
  useEffect(() => {
    // console.log('Token:', token);  // Check if token is set
    if (token) {
      axios
        .get(`${baseUrl}/districts?pagination[pageSize]=100`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          // console.log("API Response:", response.data);  // Log entire response
          if (response.data && response.data.data && Array.isArray(response.data.data)) {
            setDistricts(response.data.data);  // Set the state
            //   console.log("Districts State:", response.data); // Log districts state after setting it
          } else {
            setError("Invalid response format");
          }
        })
        .catch((error) => {
          setError("Error fetching districts");
          console.error("Error fetching districts:", error);
        });
    } else {
      setError("No token found. Please log in.");
    }
  }, [token]);

  const fetchSubDivisions = async (districtId) => {
    if (districtId) {
      // console.log(districtId);
      try {
        const response = await axios.get(`${baseUrl}/sub-divisions?filters[district][id][$eq]=${districtId}&pagination[pageSize]=200`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        // If the response data is available and valid, set the state
        setSubDivisions(response.data.data || []);
        //    console.log('Sub-Divisions:', response.data.data);  // Log response data for debugging
      } catch (error) {
        // Enhanced error logging
        if (error.response) {
          // If the error is from the server (response with status code)
          console.error('Error Response:', error.response);
          setError(`Error fetching sub-divisions: ${error.response.status} ${error.response.statusText}`);
        } else if (error.request) {
          // If the error is due to no response received
          console.error('Error Request:', error.request);
          setError('No response from the server');
        } else {
          // If something went wrong setting up the request
          console.error('Error Message:', error.message);
          setError(`Error: ${error.message}`);
        }
      }
    } else {
      setSubDivisions([]);
    }
  };
  const handleDistrictChange = (e) => {
    const selectedId = e.target.value;
    setDistrictId(selectedId);
    fetchSubDivisions(selectedId);
    setSubDivisionId('');
    setBlockId('');

  };
  const fetchBlocks = async (subDivisionId) => {
    if (subDivisionId) {
      try {
        // Modify the API endpoint and include the filters for sub-division ID
        const response = await axios.get(`${baseUrl}/blocks?filters[subDivision][id][$eq]=${subDivisionId}&pagination[pageSize]=200`, {
          headers: {
            Authorization: `Bearer ${token}`,  // Include the Authorization token if needed
          }
        });

        // Update the state with the blocks data
        setBlocks(response.data.data || []);  // Ensure the data exists and is in the expected format
        // console.log('Blocks:', response.data.data);  // Log the response data for debugging
      } catch (error) {
        console.error('Error fetching blocks:', error);  // Improved error logging
        setError("Error fetching blocks");
      }
    } else {
      // If no sub-division is selected, reset the blocks state
      setBlocks([]);
    }
  };

  const handleSubDivisionChange = (e) => {
    const selectedId = e.target.value;
    setSubDivisionId(selectedId);
    fetchBlocks(selectedId);
    setBlockId('');
  };

  const handleBlockChange = (e) => {
    const selectedId = e.target.value;
    setBlockId(selectedId);
  };
  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/roles`);  // Adjust URL if necessary
        if (response.data && Array.isArray(response.data)) {
          setRoles(response.data);  // Store the roles in state
        } else {
          setMessage("No roles found.");
        }
      } catch (error) {
        setMessage("Error fetching roles.");
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchRoles();

  }, []);


  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_AUDIT_API_URL}/api/designations?pagination[pageSize]=100`, {
        headers: {
          Authorization: `Bearer ${token}`,  // Include the Authorization token if needed
        },
      })
      .then((response) => {
        setDesignationName(response.data.data);  // Set the list of designations
      })
      .catch((error) => {
        console.error('Error fetching designation names:', error);
      });
  }, [token]);

  const handleDesignationNameChange = (e) => {
    // Update the selected designation's ID
    setSelectedDesignation(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const userData = {
      username: empId,
      employeeId: empId,
      email: email,
      password: password,
      fullname: fullname,
      // designation: designation,
      department: 2,
      role: roleId,
     // guest:false,
      mobileNum: mobileNum,
      designation: selectedDesignation,
    };
    //console.log("payload",userData)
    // Step 1: Validate phone number (must be a 10-digit number)
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(userData.mobileNum)) {
      alert("Please enter a valid 10-digit mobile number.");
      return;  // Prevent form submission if validation fails
    }

    // Step 2: Conditionally include district, subdivision, and block in the userData object
    if (districtId) {
      userData.districtId = districtId;
    }
    if (subDivisionId) {
      userData.subDivisionId = subDivisionId;
    }
    if (blockId) {
      userData.blockId = blockId;
    }

    // Step 3: Show a confirmation alert
    const isConfirmed = window.confirm("Are you sure you want to create this user?");
    if (isConfirmed) {
      try {
        const userRes = await axios.post(`${baseUrl}/poims-users/register`, userData, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        alert('User created successfully!');
        //  console.log("user data is", userRes.data);

        // Prepare postingData, conditionally include fields
        const postingData = {
          data: {
            poimsUser: userRes.data.id,
          }
        };

        if (blockId) {
          postingData.data.postingBlock = blockId;
        }
        if (districtId) {
          postingData.data.postingDistrict = districtId;
        }
        if (subDivisionId) {
          postingData.data.postingSubDivision = subDivisionId;
        }

        //  console.log(postingData);  // Log the data being sent to check for empty values
        // Only send if there's any posting data
        if (Object.keys(postingData.data).length > 1) {
          await axios.post(`${baseUrl}/user-postings`, postingData, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          });
        }

        // Step 4: Handle success
        setMessage("User created and posted successfully!");
        // Reset all form fields after success
        setUserName('');
        setEmpId('');
        setEmail('');
        setPassword('');
        setDesignation('');
        setMobileNum('');
        setRoleId('');
        setDistrictId('');
        setSubDivisionId('');
        setBlockId('');
        setConfirmPassword('');
        setPasswordStrength('');
        setPasswordMatchError('');
        // setDesignationName('');
        setSelectedDesignation('');
        setMessage('');
        setError(null);
      } catch (error) {
        // Step 5: Handle errors (show red message and reset form)
        if (error.response) {
          console.error("Error registering user:", error.response.data);
          setMessage(`Error: ${error.response.data.message || 'Please try again.'}`);
          alert(`Error: ${error.response.data.message || 'User already exists.'}`)
        } else {
          console.error("An error occurred:", error.message);
          setMessage("An error occurred. Please try again.");
        }

        // Clear all form fields after failure
        setUserName('');
        setEmpId('');
        setEmail('');
        setPassword('');
        setDesignation('');
        setMobileNum('');
        setRoleId('');
        setDistrictId('');
        setSubDivisionId('');
        setBlockId('');
        setConfirmPassword('');
        setPasswordStrength('');
        setPasswordMatchError('');
        setMessage('');
        setSelectedDesignation('');
        setError(null);
      }
    }
  };



  // Cancel button handler
  const handleCancelButtonClick = () => {
    navigate('/');
  };
  const capitalizeFirstLetter = (text) => {
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  };

  return (
    <div className="create-user-container">
      {/* <h2 className="form-title">Create User</h2> */}
      <div className="create-card">
        <div className="create-card-header">Create User</div>
        <form className="form-body" onSubmit={handleSubmit}>
          <div className="form-group-cu">
            <label className="cre-text-1" htmlFor="employeId"><span className="asterisk">*</span>Employee ID</label>
            <input
              type="text"
              id="employeId"
              value={empId}
              onChange={(e) => setEmpId(e.target.value)}
              required
            />
          </div>

          <div className="form-group-cu">
            <label className="cre-text-2" htmlFor="userName"><span className="asterisk">*</span>Full Name</label>
            <input
              type="text"
              id="userName"
              value={fullname}
              onChange={(e) => setUserName(e.target.value)}
              required

            />
          </div>

          <div className="form-group-cu">
            <label className="cre-text-3" htmlFor="designation"><span className="asterisk">*</span>Designation</label>
            <select
              className="designation"
              value={selectedDesignation}  // Set selected value from state
              onChange={handleDesignationNameChange}  // Handle the change in selection
              required
            >
              <option value="" hidden disabled>Select Designation</option>  {/* Default option */}
              {designationName.length > 0 ? (
                designationName
                  .sort((a, b) => a.designationName.localeCompare(b.designationName)) // Sort alphabetically A-Z
                  .map((designation) => (
                    <option key={designation.id} value={designation.designationName}>
                      {designation.designationName}  {/* Display designation name */}
                    </option>
                  ))
              ) : (
                <option value="">No designations available</option>
              )}
            </select>

          </div>

          <div className="form-group-cu">
            <label className="cre-text-4" htmlFor="role"><span className="asterisk">*</span>Role</label>
            <select
              id="role"
              value={roleId}
              onChange={(e) => setRoleId(e.target.value)}
              required
            >
               <option value="" disabled hidden>Select</option>
              {loading ? (
                <option value="" disabled>Loading roles...</option>
              ) : (
                roles.map((role) => (
                  <option key={role.roleId} value={role.roleId}>
                    {role.roleName} {/* Display role name */}
                  </option>
                ))
              )}
            </select>
          </div>

          <div className="form-group-cu">
            <label className="cre-text-5" htmlFor="email"><span className="asterisk">*</span>Email ID</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter Email"
              required
            />
          </div>

          <div className="form-group-cu">
            <label className="cre-text-6" htmlFor="mobileNum"><span className="asterisk">*</span>Mobile Number</label>
            <input
              type="text"
              id="mobileNum"
              value={mobileNum}
              onChange={(e) => setMobileNum(e.target.value)}
              placeholder="Enter Mobile Number"
              required
            />
          </div>

          <div className="form-group-cu">
            <label className="cre-text-7" htmlFor="district">District</label>
            <select
              id="district"
              value={districtId}
              onChange={handleDistrictChange}

            // required
            >
              <option value="" disabled hidden>District</option>
              {districts.sort((a, b) => a.districtName.localeCompare(b.districtName)).map((dist) => (
                <option key={dist.id} value={dist.id}>
                  {/* {dist.districtName} */}
                  {capitalizeFirstLetter(dist.districtName)}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group-cu">
            <label className="cre-text-8" htmlFor="subDivision">Sub Division</label>
            <select
              id="subDivision"
              value={subDivisionId}
              onChange={handleSubDivisionChange}
            // required
            >
              <option value="" disabled hidden >Sub Division</option>
              {subDivisions.sort((a, b) => a.subDivisionName.localeCompare(b.subDivisionName)).map((sub) => (
                <option key={sub.id} value={sub.id}>
                  {capitalizeFirstLetter(sub.subDivisionName)}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group-cu">
            <label className="cre-text-9" htmlFor="block">Block</label>
            <select
              id="block"
              value={blockId}
              onChange={handleBlockChange}
            // required
            >
              <option value="" disabled hidden >Block</option>
              {blocks.sort((a, b) => a.blockName.localeCompare(b.blockName)).map((blo) => (
                <option key={blo.id} value={blo.id}>
                  {/* {blo.blockName} */}
                  {capitalizeFirstLetter(blo.blockName)}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group-cu">
            <label className="cre-text-10" htmlFor="password"><span className="asterisk">*</span>Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={handlePasswordChange}
              placeholder="Enter Password"
              required
            />
            {password && (
              <div className="password-strength-message" style={{ color: passwordStrength === 'Strong' ? 'green' : passwordStrength === 'Medium' ? 'orange' : 'red' }}>
                <strong>{passwordStrength}</strong>
              </div>
            )}
          </div>

          <div className="form-group-cu">
            <label htmlFor="conformPassword"><span className="asterisk">*</span>Confirm Password</label>
            <input
              type="password"
              id="conformPassword"
              value={confirmPassword}
              onChange={handleConfirmPasswordChange}
              required
              placeholder="Confirm Password"
            />
            <div className="password-strength-message">
              {passwordMatchError && <p style={{ color: 'red' }}>{passwordMatchError}</p>}

            </div>

          </div>

          <div className="createUserButtons">
            <button className="createUser-btn">Create User</button>
            <button className="btn-createUser" onClick={handleCancelButtonClick}>CANCEL</button>
          </div>

        </form>
      </div>
    </div>
  );
};

export default CreateUser;
